/**
 * Gestionnaire de consentement cookies e-maprod (RGPD-compliant).
 *
 * Architecture :
 *   - Bannière basse au 1er visite (accepter tout / refuser tout / personnaliser)
 *   - Modal de préférences avec cases par catégorie
 *   - Puce persistante bottom-left pour réouvrir les préférences après choix
 *   - Stockage localStorage : { version, timestamp, categories: {analytics, marketing} }
 *   - Re-ask automatique après 13 mois (bump version = force reset)
 *   - Intégration Google Analytics 4 via gtag('consent','update',...)
 *     (le tag est chargé au top de <head> avec 'denied' par défaut)
 *   - Event custom `emaprod:consent-updated` (details.categories) pour
 *     brancher d'autres scripts optionnels (Meta Pixel, etc.)
 *
 * Config exposée par le layout Twig :
 *   window.EMAPROD_COOKIE_CONFIG = { hasGA: boolean, policyUrl: string }
 */
var STORAGE_KEY = 'emaprod_cookie_consent';
var CONSENT_VERSION = 1; // Incrémenter pour re-demander à tous les visiteurs
var MAX_AGE_DAYS = 13 * 30; // ~13 mois (guideline CNIL/APD)
// ------ Persistance ------
function loadConsent() {
    try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        var state = JSON.parse(raw);
        if (state.version !== CONSENT_VERSION)
            return null;
        // Expiré ?
        var ageMs = Date.now() - state.timestamp;
        if (ageMs > MAX_AGE_DAYS * 24 * 3600 * 1000)
            return null;
        return state;
    }
    catch (e) {
        return null;
    }
}
function saveConsent(categories) {
    var state = {
        version: CONSENT_VERSION,
        timestamp: Date.now(),
        categories: categories
    };
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }
    catch (e) { }
    applyConsent(state);
    document.dispatchEvent(new CustomEvent('emaprod:consent-updated', { detail: state }));
}
// ------ Application ------
function applyConsent(state) {
    var _a;
    // GA4 : update le Consent Mode
    if (((_a = window.EMAPROD_COOKIE_CONFIG) === null || _a === void 0 ? void 0 : _a.hasGA) && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
            analytics_storage: state.categories.analytics ? 'granted' : 'denied',
            ad_storage: state.categories.marketing ? 'granted' : 'denied',
            ad_user_data: state.categories.marketing ? 'granted' : 'denied',
            ad_personalization: state.categories.marketing ? 'granted' : 'denied'
        });
    }
}
// ------ Icônes SVG (sans emoji) ------
var ICON_COOKIE = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\">\n    <path d=\"M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5\"/>\n    <path d=\"M8.5 8.5v.01\"/><path d=\"M16 15.5v.01\"/><path d=\"M12 12v.01\"/>\n    <path d=\"M11 17v.01\"/><path d=\"M7 14v.01\"/>\n</svg>";
var ICON_CLOSE = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\">\n    <path d=\"M18 6L6 18M6 6l12 12\"/>\n</svg>";
var ICON_CHEVRON = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\">\n    <polyline points=\"6 9 12 15 18 9\"/>\n</svg>";
var COOKIE_INVENTORY = {
    necessary: [
        { name: 'emaprod_cookie_consent', domain: 'emaprod.com', purpose: 'Mémorise vos préférences de consentement cookies.', duration: '13 mois' },
        { name: 'wordpress_logged_in_*', domain: 'emaprod.com', purpose: 'Session utilisateur connecté (admin uniquement).', duration: 'Session' },
        { name: 'wp-settings-*', domain: 'emaprod.com', purpose: 'Préférences d\'interface (admin uniquement).', duration: '1 an' },
        { name: 'pll_language', domain: 'emaprod.com', purpose: 'Mémorise votre choix de langue (Polylang).', duration: '1 an' },
    ],
    analytics: [
        { name: '_ga', domain: 'google.com', purpose: 'Identifie les visiteurs uniques pour Google Analytics 4.', duration: '2 ans' },
        { name: '_ga_*', domain: 'google.com', purpose: 'Session GA4 (spécifique à la propriété de mesure).', duration: '2 ans' },
        { name: '_gid', domain: 'google.com', purpose: 'Distingue les utilisateurs sur 24 h (legacy Universal Analytics).', duration: '24 heures' },
    ],
    marketing: []
};
// ------ Rendu bannière ------
function renderBanner() {
    var _a;
    var el = document.createElement('div');
    el.className = 'cookie-banner';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-labelledby', 'cookie-banner-title');
    el.setAttribute('aria-live', 'polite');
    var policyUrl = ((_a = window.EMAPROD_COOKIE_CONFIG) === null || _a === void 0 ? void 0 : _a.policyUrl) || '/politique-de-confidentialite/';
    el.innerHTML = "\n        <div class=\"cookie-banner__inner\">\n            <div class=\"cookie-banner__text\">\n                <p id=\"cookie-banner-title\" class=\"cookie-banner__title\">Cookies</p>\n                <p class=\"cookie-banner__body\">\n                    Nous utilisons des cookies pour am\u00E9liorer votre navigation et mesurer l'audience du site.\n                    Vous pouvez accepter, refuser ou personnaliser vos choix \u00E0 tout moment.\n                    <a href=\"" + policyUrl + "\" class=\"cookie-banner__link\">En savoir plus</a>.\n                </p>\n            </div>\n            <div class=\"cookie-banner__actions\">\n                <button type=\"button\" class=\"cookie-banner__btn cookie-banner__btn--ghost\" data-action=\"customize\">Personnaliser</button>\n                <button type=\"button\" class=\"cookie-banner__btn cookie-banner__btn--secondary\" data-action=\"reject\">Refuser tout</button>\n                <button type=\"button\" class=\"cookie-banner__btn cookie-banner__btn--primary\" data-action=\"accept\">Accepter tout</button>\n            </div>\n        </div>\n    ";
    document.body.appendChild(el);
    return el;
}
// ------ Rendu de la liste des cookies (tableau accordéon) ------
function renderCookieList(category) {
    var rows = COOKIE_INVENTORY[category];
    if (!rows || rows.length === 0) {
        return "<p class=\"cookie-list__empty\">Aucun cookie de cette cat\u00E9gorie n'est actuellement utilis\u00E9 sur ce site.</p>";
    }
    var rowsHtml = rows.map(function (r) { return "\n        <tr>\n            <td class=\"cookie-list__name\"><code>" + r.name + "</code></td>\n            <td class=\"cookie-list__provider\">" + r.domain + "</td>\n            <td class=\"cookie-list__purpose\">" + r.purpose + "</td>\n            <td class=\"cookie-list__duration\">" + r.duration + "</td>\n        </tr>\n    "; }).join('');
    return "\n        <div class=\"cookie-list__wrap\">\n            <table class=\"cookie-list__table\">\n                <thead>\n                    <tr>\n                        <th>Nom</th>\n                        <th>Fournisseur</th>\n                        <th>Description</th>\n                        <th>Dur\u00E9e</th>\n                    </tr>\n                </thead>\n                <tbody>" + rowsHtml + "</tbody>\n            </table>\n        </div>\n    ";
}
// ------ Rendu modal préférences ------
function renderModal(currentState) {
    var _a, _b, _c;
    var analytics = (_a = currentState === null || currentState === void 0 ? void 0 : currentState.categories.analytics) !== null && _a !== void 0 ? _a : false;
    var marketing = (_b = currentState === null || currentState === void 0 ? void 0 : currentState.categories.marketing) !== null && _b !== void 0 ? _b : false;
    var policyUrl = ((_c = window.EMAPROD_COOKIE_CONFIG) === null || _c === void 0 ? void 0 : _c.policyUrl) || '/politique-de-confidentialite/';
    var el = document.createElement('div');
    el.className = 'cookie-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'cookie-modal-title');
    el.innerHTML = "\n        <div class=\"cookie-modal__backdrop\" data-action=\"close\"></div>\n        <div class=\"cookie-modal__box\">\n            <div class=\"cookie-modal__head\">\n                <h2 id=\"cookie-modal-title\" class=\"cookie-modal__title\">G\u00E9rer les cookies</h2>\n                <button type=\"button\" class=\"cookie-modal__close\" data-action=\"close\" aria-label=\"Fermer\">" + ICON_CLOSE + "</button>\n            </div>\n            <div class=\"cookie-modal__body\">\n                <p class=\"cookie-modal__intro\">\n                    Choisissez les cookies que vous souhaitez autoriser sur ce site.\n                    Vous pourrez modifier vos pr\u00E9f\u00E9rences \u00E0 tout moment via l'ic\u00F4ne en bas \u00E0 gauche.\n                    <a href=\"" + policyUrl + "\" class=\"cookie-modal__link\">Politique de confidentialit\u00E9</a>.\n                </p>\n\n                <div class=\"cookie-category\">\n                    <div class=\"cookie-category__head\">\n                        <label class=\"cookie-category__label\">Strictement n\u00E9cessaires</label>\n                        <span class=\"cookie-category__badge\">Toujours actifs</span>\n                    </div>\n                    <p class=\"cookie-category__desc\">\n                        Ces cookies sont indispensables au bon fonctionnement du site (authentification, pr\u00E9f\u00E9rence de langue,\n                        m\u00E9morisation du consentement lui-m\u00EAme). Ils ne peuvent pas \u00EAtre d\u00E9sactiv\u00E9s.\n                    </p>\n                    <button type=\"button\" class=\"cookie-category__toggle\" data-toggle=\"necessary\" aria-expanded=\"false\">\n                        <span class=\"cookie-category__toggle-label\">Voir la liste des cookies (" + COOKIE_INVENTORY.necessary.length + ")</span>\n                        <span class=\"cookie-category__toggle-icon\">" + ICON_CHEVRON + "</span>\n                    </button>\n                    <div class=\"cookie-category__list\" data-list=\"necessary\" hidden>" + renderCookieList('necessary') + "</div>\n                </div>\n\n                <div class=\"cookie-category\">\n                    <div class=\"cookie-category__head\">\n                        <label class=\"cookie-category__label\" for=\"cookie-cat-analytics\">Mesure d'audience</label>\n                        <input type=\"checkbox\" id=\"cookie-cat-analytics\" data-category=\"analytics\" " + (analytics ? 'checked' : '') + ">\n                    </div>\n                    <p class=\"cookie-category__desc\">\n                        Google Analytics 4 avec anonymisation IP. Nous aide \u00E0 comprendre comment les visiteurs\n                        utilisent le site pour l'am\u00E9liorer. Aucune donn\u00E9e n'est vendue \u00E0 des tiers.\n                    </p>\n                    <button type=\"button\" class=\"cookie-category__toggle\" data-toggle=\"analytics\" aria-expanded=\"false\">\n                        <span class=\"cookie-category__toggle-label\">Voir la liste des cookies (" + COOKIE_INVENTORY.analytics.length + ")</span>\n                        <span class=\"cookie-category__toggle-icon\">" + ICON_CHEVRON + "</span>\n                    </button>\n                    <div class=\"cookie-category__list\" data-list=\"analytics\" hidden>" + renderCookieList('analytics') + "</div>\n                </div>\n\n                <div class=\"cookie-category\">\n                    <div class=\"cookie-category__head\">\n                        <label class=\"cookie-category__label\" for=\"cookie-cat-marketing\">Marketing</label>\n                        <input type=\"checkbox\" id=\"cookie-cat-marketing\" data-category=\"marketing\" " + (marketing ? 'checked' : '') + ">\n                    </div>\n                    <p class=\"cookie-category__desc\">\n                        Cookies utilis\u00E9s pour proposer des contenus adapt\u00E9s (r\u00E9seaux sociaux embarqu\u00E9s, publicit\u00E9s cibl\u00E9es).\n                        Actuellement non utilis\u00E9s sur ce site.\n                    </p>\n                    <button type=\"button\" class=\"cookie-category__toggle\" data-toggle=\"marketing\" aria-expanded=\"false\">\n                        <span class=\"cookie-category__toggle-label\">Voir la liste des cookies (" + COOKIE_INVENTORY.marketing.length + ")</span>\n                        <span class=\"cookie-category__toggle-icon\">" + ICON_CHEVRON + "</span>\n                    </button>\n                    <div class=\"cookie-category__list\" data-list=\"marketing\" hidden>" + renderCookieList('marketing') + "</div>\n                </div>\n            </div>\n            <div class=\"cookie-modal__foot\">\n                <button type=\"button\" class=\"cookie-banner__btn cookie-banner__btn--secondary\" data-action=\"reject\">Refuser tout</button>\n                <button type=\"button\" class=\"cookie-banner__btn cookie-banner__btn--primary\" data-action=\"save\">Enregistrer mes choix</button>\n            </div>\n        </div>\n    ";
    document.body.appendChild(el);
    return el;
}
// ------ Rendu puce persistante (bottom-left) ------
function renderChip() {
    if (document.querySelector('.cookie-chip'))
        return;
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'cookie-chip';
    el.setAttribute('aria-label', 'Gérer mes cookies');
    el.title = 'Gérer mes cookies';
    el.innerHTML = ICON_COOKIE;
    el.addEventListener('click', openModal);
    document.body.appendChild(el);
}
// ------ Contrôleurs UI ------
var modalEl = null;
var bannerEl = null;
function openModal() {
    if (modalEl)
        return;
    var current = loadConsent();
    modalEl = renderModal(current);
    requestAnimationFrame(function () { return modalEl === null || modalEl === void 0 ? void 0 : modalEl.classList.add('is-open'); });
    modalEl.addEventListener('click', function (e) {
        var _a;
        var target = e.target;
        // Toggle "Voir la liste des cookies" par catégorie
        var toggleBtn = target.closest('[data-toggle]');
        if (toggleBtn && modalEl) {
            var cat = toggleBtn.dataset.toggle;
            var list = modalEl.querySelector("[data-list=\"" + cat + "\"]");
            var isOpen = list && !list.hasAttribute('hidden');
            if (list) {
                if (isOpen) {
                    list.setAttribute('hidden', '');
                    toggleBtn.setAttribute('aria-expanded', 'false');
                    toggleBtn.classList.remove('is-open');
                }
                else {
                    list.removeAttribute('hidden');
                    toggleBtn.setAttribute('aria-expanded', 'true');
                    toggleBtn.classList.add('is-open');
                }
            }
            return;
        }
        var action = (_a = target.closest('[data-action]')) === null || _a === void 0 ? void 0 : _a.dataset.action;
        if (!action)
            return;
        if (action === 'close')
            closeModal();
        else if (action === 'reject') {
            saveAll(false);
            closeModal();
            closeBanner();
        }
        else if (action === 'save') {
            saveFromCheckboxes();
            closeModal();
            closeBanner();
        }
    });
}
function closeModal() {
    modalEl === null || modalEl === void 0 ? void 0 : modalEl.classList.remove('is-open');
    var el = modalEl;
    modalEl = null;
    setTimeout(function () { return el === null || el === void 0 ? void 0 : el.remove(); }, 220);
}
function closeBanner() {
    bannerEl === null || bannerEl === void 0 ? void 0 : bannerEl.classList.remove('is-open');
    var el = bannerEl;
    bannerEl = null;
    setTimeout(function () { el === null || el === void 0 ? void 0 : el.remove(); renderChip(); }, 220);
}
function saveAll(value) {
    saveConsent({ analytics: value, marketing: value });
}
function saveFromCheckboxes() {
    var _a, _b;
    var analytics = !!((_a = document.getElementById('cookie-cat-analytics')) === null || _a === void 0 ? void 0 : _a.checked);
    var marketing = !!((_b = document.getElementById('cookie-cat-marketing')) === null || _b === void 0 ? void 0 : _b.checked);
    saveConsent({ analytics: analytics, marketing: marketing });
}
// ------ Init ------
export function initCookieBanner() {
    // Skip si utilisateur admin logged in (évite le nag en édition)
    if (document.body.classList.contains('logged-in')) {
        // On affiche quand même la puce pour tester
        var existing_1 = loadConsent();
        if (existing_1) {
            applyConsent(existing_1);
            renderChip();
        }
        return;
    }
    var existing = loadConsent();
    if (existing) {
        applyConsent(existing);
        renderChip();
        return;
    }
    // Pas de consentement stocké → afficher la bannière
    bannerEl = renderBanner();
    requestAnimationFrame(function () { return bannerEl === null || bannerEl === void 0 ? void 0 : bannerEl.classList.add('is-open'); });
    bannerEl.addEventListener('click', function (e) {
        var _a;
        var target = e.target;
        var action = (_a = target.closest('[data-action]')) === null || _a === void 0 ? void 0 : _a.dataset.action;
        if (!action)
            return;
        if (action === 'accept') {
            saveAll(true);
            closeBanner();
        }
        else if (action === 'reject') {
            saveAll(false);
            closeBanner();
        }
        else if (action === 'customize') {
            openModal();
        }
    });
}
